import React, { useMemo } from "react";
import Chip from "../../../components/chip";
import { sf_hachtoan_congno_viewmodel } from "../../../models/response/hach-toan-cong-no/sf_hachtoan_congno";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/reducers";
import styles from "./HachToanSummary.module.css";
interface IHachToanSummaryProps {
  sf_hachtoan_congno_viewmodels: sf_hachtoan_congno_viewmodel[];
  selectedId: number;
  onSelectedChanged: (id: number) => void;
}
const hachToanTypes = [
  { id: -1, text: "Tất cả" },
  { id: 1, text: "Tiền ăn" },
  { id: 2, text: "Tiền xe" },
  { id: 3, text: "Tiền thừa" },
  { id: 4, text: "Tiền thiếu" },
  { id: 0, text: "Khác" },
];
const HachToanSummary = (props: IHachToanSummaryProps) => {
    const { dm_coso_id } = useSelector((x: RootState) => x.common)
  const dataSource = useMemo(() => {
    return hachToanTypes.map((x) => {
      const count = props.sf_hachtoan_congno_viewmodels.filter(
        (y) => y.dm_coso_id === dm_coso_id && y.sf_hoanphi_type_id === x.id
      ).length;
      return {
        ...x,
        count: count,
      };
    });
  }, [props.sf_hachtoan_congno_viewmodels, hachToanTypes, dm_coso_id]);
  return (
    <div className={styles.container}>
      {dataSource.map((x) => {
        return (
          <Chip
            key={x.id}
            count={x.count}
            isSeleted={x.id == props.selectedId}
            id={x.id}
            onClick={() => {
              props.onSelectedChanged(x.id);
            }}
            text={x.text}
          />
        );
      })}
    </div>
  );
};

export default HachToanSummary;
